import { BulkPutOrderRequest, EditableProperties } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 発注カレンダーの発注情報を更新する際のリクエスト情報を生成するアダプタ
 */
export class UpdateOrderAdapter {
  /**
   * 発注情報を更新する際のリクエスト情報を生成する
   * @param orders - 発注情報
   */
  public static adapt(orders: CalendarOrder[]): BulkPutOrderRequest {
    return {
      bulkPutOrderInfo: orders.map((order) => ({
        orderId: order.arrivalId,
        orderAmount: order.amount.toString(),
        orderStatus: order.status,
        orderNote: order.memoText,
        orderEstimateTimeOfArrival: order.crossDate ? DateService.formatIDateToISOString(order.crossDate) : undefined,
        updateAt: order.updateAt,
      })),
    };
  }
}
